import type { PartCategory } from "./types";

export const CATEGORY_LABELS: Record<PartCategory, string> = {
  nose: "Nose cones",
  fuselage: "Bodies",
  engine: "Engines",
  fin: "Fins",
  booster: "Boosters",
  window: "Windows",
};

export const CATEGORY_TAB_LABELS: Record<PartCategory, string> = {
  nose: "Nose",
  fuselage: "Body",
  engine: "Engine",
  fin: "Fins",
  booster: "Boost",
  window: "Window",
};

export const CATEGORY_ORDER: PartCategory[] = [
  "nose",
  "fuselage",
  "engine",
  "fin",
];
